import React from 'react';
import palette from '../../color-palette';

interface VegetarianTagProps {
  background?: string;
  tag?: string;
  className?: string;
}

const VegetarianTag = ({
  background = palette.background.default,
  tag = palette.secondary.main,
  className,
}: VegetarianTagProps) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="2 0 10 14"
    width="11"
    height="25"
    xmlSpace="preserve"
    data-testid="vegetarian-tag"
    className={className}
    fill={background}
    aria-label="vegetarian tag"
  >
    <path
      fill={tag}
      d="M6.98,8.23c0.06-0.29,0.12-0.56,0.18-0.84c0.16-0.72,0.33-1.43,0.47-2.15c0.23-1.16,0.43-2.19,0.65-3.36
		c0.03-0.16,0.06-0.32,0.1-0.48c0.03-0.12,0.1-0.22,0.32-0.25c0.22-0.04,1.5-0.39,2.36-0.37c0.18,0.01,0.23,0.09,0.29,0.2
		c0.12,0.2,0.26,0.69,0.21,0.92c-0.04,0.16-0.07,0.32-0.11,0.48c-0.34,1.26-0.68,2.52-1.01,3.78c-0.1,0.37-0.19,0.75-0.29,1.13
		C10,7.81,9.85,8.34,9.64,8.85c-0.23,0.57-0.33,1.18-0.47,1.77c-0.14,0.6-0.35,1.4-0.66,1.82c-0.31,0.43-0.49,0.54-0.69,0.61
		c-0.21,0.06-0.42,0.04-1.1,0.1c-0.68,0.06-0.56-0.05-0.85-0.1c-0.3-0.05-0.5-0.66-0.71-1.06c-0.19-0.37-0.37-1.04-0.53-1.76
		c-0.13-0.58-0.3-1.14-0.5-1.7C3.96,8.05,3.81,7.56,3.68,7.06C3.27,5.55,3,4.03,2.6,2.51C2.56,2.33,2.52,2.15,2.47,1.98
		C2.41,1.79,2.44,1.62,2.5,1.44c0.09-0.26,0.99-0.4,1.39-0.5c0.39-0.1,1.17-0.17,1.36-0.15c0.11,0.01,0.18,0.09,0.22,0.19
		C5.49,1.01,5.5,1.05,5.51,1.09c0.19,1,0.39,2.28,0.59,3.28c0.24,1.2,0.49,2.4,0.74,3.59C6.85,8.05,6.86,8.16,6.98,8.23z"
    />
  </svg>
);

export default VegetarianTag;
